import React from 'react'

const MonitorSize = () => {
  return (
    <div className='text-sm p-3 gap-3 w-full h-screen flex flex-col justify-center items-center'>

      {/* 상단 문구 */}
      <div className='flex flex-col justify-center items-center'>
        {/* <img className='w-32' src="./vapemarket_logo.png" alt="logo" /> */}
        <div className='lg:relative lg:min-w-[305px] p-3 cursor-pointer text-3xl text-yellow-400 mx-5' style={{ fontFamily: 'Nosifer, cursive'}}>
          <p className='active:scale-y-[-1] hover:scale-95 duration-100'>
            VapeMarket
          </p>
        </div>
      </div>

      {/* 메인 문구 */}
      <div className='flex flex-col justify-center items-center w-full gap-5 h-full p-3 rounded-md bg-[#3E3E3E]'>
        <p className="text-5xl">🖥️<span className='animate-pulse tracking-widest'>...</span></p>
        <p className='whitespace-normal font-bold text-base'>
          <span className='text-yellow-500'>※ </span>
          브라우저 사이즈가 작습니다, 브라우저 크기를 늘려서 사용해 주세요.
        </p>
      </div>

      {/* 하단 문구 */}
      <div className='w-full'>
        <div className='p-3 bg-blue-500/60 rounded-md'>
          <p>화면의 2/1 or 3/1 사이즈로 최적화되어있습니다.</p>
        </div>
      </div>

    </div>
  )
}

export default MonitorSize